import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import classNames from "classnames"

import onboardingStyles from "../Onboarding.module.scss"
import styles from "./GetStarted.module.scss"
import { OnboardingPageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"

const prefix = "pages.onboarding.get_started."

export function GetStarted() {
  const polyglot = usePolyglot()

  return (
    <OnboardingPageTemplate
      title={polyglot.t(`${prefix}title`)}
      hideUserName
    >
      <div className={classNames(
        onboardingStyles.container,
        styles.container,
      )}
      >
        <div className={onboardingStyles.subtitle}>
          {polyglot.t(`${prefix}subtitle`)}
        </div>
        <div className={styles.description}>
          {polyglot.t(`${prefix}description`)}
        </div>
        <ActionLink
          asChild
          stylePreset="secondary"
        >
          <Link
            to="/onboarding/data_source"
            id="add-my-own-data-source-btn"
          >
            {polyglot.t(`${prefix}add_data_source_cta`)}
          </Link>
        </ActionLink>
        <ActionLink
          asChild
          stylePreset="secondary"
        >
          <Link to="/onboarding/accept_invite">
            {polyglot.t(`${prefix}accept_invite_cta`)}
          </Link>
        </ActionLink>
      </div>
    </OnboardingPageTemplate>
  )
}
